import {
  FACILITY_SEARCH, FACILITY_SEARCH_SUCCESS, FACILITY_SEARCH_FAILURE, FACILITY_SEARCH_AUTOCOMPLETE_SUCCESS, FACILITY_CLEAR, FACILITY_AUTOCOMPLETE_CLEAR,
  FACILITY_SELECT,
  FACILITY_NOTICE_GET, FACILITY_NOTICE_GET_SUCCESS, FACILITY_NOTICE_GET_FAILURE,
  FACILITY_NOTICE_COMPLETE, FACILITY_NOTICE_COMPLETE_SUCCESS, FACILITY_NOTICE_COMPLETE_FAILURE,
  FACILITY_NOTICE_DELETE, FACILITY_NOTICE_DELETE_SUCCESS, FACILITY_NOTICE_DELETE_FAILURE,
  FACILITY_SEARCH_ALL, FACILITY_SEARCH_ALL_SUCCESS, FACILITY_SEARCH_ALL_FAILURE, FACILITY_CHECKED,
  FACILITY_SHOP_LIST_SAVE, FACILITY_SEARCH_BY_SHOP, FACILITY_SEARCH_BY_SHOP_SUCCESS, FACILITY_SEARCH_BY_SHOP_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    facilities: null,
    facilitiesAutocomplete: null,
    facilitiesCurrentPage: null,
    facilitiesNextPage: null,
    facilitiesPrevPage: null,
    facilitiesTotalCount: 0,
    searchParams: null,
    selectedFacilities: null,
    facilityNotices: null,
    facilityNotify: null,
    shopList: [],
    searchFacilitiesByShop: null
  },
  getters: {
    facilities: state => {
      return state.facilities
    },
    facilitiesAutocomplete: state => {
      return state.facilitiesAutocomplete
    },
    facilitiesCurrentPage: state => {
      return state.facilitiesCurrentPage
    },
    facilitiesNextPage: state => {
      return state.facilitiesNextPage
    },
    facilitiesPrevPage: state => {
      return state.facilitiesPrevPage
    },
    facilitiesTotalCount: state => {
      return state.facilitiesTotalCount
    },
    facilitiesSearchParams: state => {
      return state.searchParams
    },
    selectedFacilities: state => {
      return state.selectedFacilities
    },
    searchFacilitiesByShop: state => {
      return state.searchFacilitiesByShop
    },
    searchFacilitiesShopList: state => {
      return state.shopList
    },
    facilityNotices: state => {
      return state.facilityNotices
    },
    facilityNotify: state => {
      return state.facilityNotify
    }
  },
  actions: {
    [FACILITY_SEARCH] ({dispatch, state, commit}, params) {
      var url = '/facilities'
      var data = {}
      var loadparams = true
      var callback = () => {}
      if (params) {
        if (params.url && !params.clear) {
          url = params.url
        }
        if (params.clear) {
          state.facilities = null
          state.facilitiesAutocomplete = null
          state.facilitiesCurrentPage = null
          state.facilitiesNextPage = null
          state.facilitiesPrevPage = null
          state.facilitiesTotalCount = 0
        }
        state.searchParams = params.data
        data = params.data
        if (params.autocomplete) {
          loadparams = false
        }
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(FACILITY_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            if (params.autocomplete) {
              commit(FACILITY_SEARCH_AUTOCOMPLETE_SUCCESS, {data: res.data, params: params, callback: callback})
            } else {
              commit(FACILITY_SEARCH_SUCCESS, {data: res.data, params: params, callback: callback})
            }
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [FACILITY_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(FACILITY_CLEAR)
      }, sleep)
    },
    [FACILITY_AUTOCOMPLETE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(FACILITY_AUTOCOMPLETE_CLEAR)
      }, sleep)
    },
    [FACILITY_SELECT] ({state, commit}, params) {
      commit(FACILITY_SELECT, params)
    },
    [FACILITY_NOTICE_GET] ({dispatch, state, commit}, params) {
      var url = '/facilities/get_notices'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_NOTICE_GET_FAILURE, res.data)
            } else {
              commit(FACILITY_NOTICE_GET_SUCCESS, {
                data: res.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [FACILITY_NOTICE_COMPLETE] ({dispatch, state, commit}, params) {
      var url = '/facilities/complete_notice'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_NOTICE_COMPLETE_FAILURE, res.data)
            } else {
              commit(FACILITY_NOTICE_COMPLETE_SUCCESS, {
                data: res.data,
                params: params.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [FACILITY_NOTICE_DELETE] ({dispatch, state, commit}, params) {
      var url = '/facilities/delete_notice'
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiDelete', {url: url, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(FACILITY_NOTICE_DELETE_FAILURE, res.data)
            } else {
              commit(FACILITY_NOTICE_DELETE_SUCCESS, {
                data: res.data,
                params: params.data,
                callback: params.callback
              })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [FACILITY_SEARCH_ALL] ({dispatch, state, commit}, params) {
      var url = '/facilities/search_all'
      var data = {}
      var callback = () => {}
      if (params) {
        state.searchParams = params.data
        data = params.data
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(FACILITY_SEARCH_ALL_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(FACILITY_SEARCH_ALL_SUCCESS, {data: res.data, params: params, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [FACILITY_SEARCH_BY_SHOP] ({dispatch, state, commit}, params) {
      var url = '/facilities/search_by_shops'
      var data = {}
      var callback = () => {}
      if (params) {
        state.searchParams = params.data
        data = params.data
        if ('callback' in params) {
          callback = params.callback
        }
      }
      dispatch('apiGet', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(FACILITY_SEARCH_BY_SHOP_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(FACILITY_SEARCH_BY_SHOP_SUCCESS, {data: res.data, params: params, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [FACILITY_CHECKED] ({state, commit}, params) {
      commit(FACILITY_CHECKED, params)
    },
    [FACILITY_SHOP_LIST_SAVE] ({state, commit}, params) {
      commit(FACILITY_SHOP_LIST_SAVE, params)
    }
  },
  mutations: {
    [FACILITY_SEARCH_FAILURE] (state, data) {
      console.log('FACILITY_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [FACILITY_SEARCH_SUCCESS] (state, {data, params}) {
      console.log('FACILITY_SEARCH_SUCCESS')
      var reSearch = false

      var sendFailsMerge = function (rows, meta) {
        if (meta && !('send-fails' in meta)) {
          return rows
        }
        var result = []
        var sendFails = meta['send-fails']
        rows.forEach(function (row) {
          for (var i = 0; i < sendFails.length; i++) {
            if (parseInt(row['id'], 10) === parseInt(sendFails[i]['facility-id'], 10)) {
              row.attributes['send-fails'] = sendFails[i]['send-fails']
              break
            }
          }
          result.push(row)
        })
        return result
      }

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (params.checkall) {
        data.data = data.data.filter(function (f) {
          f.checked = params.checkall
          return true
        })
      }

      if (reSearch) {
        // 再検索
        state.facilities = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.facilitiesNextPage = null
        }
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.facilities = state.facilities.concat(data.data)
          state.facilitiesCurrentPage = data.meta['current-page']
        } else {
          state.facilities = data.data
          state.facilitiesCurrentPage = 1
        }

        state.facilitiesNextPage = null
        if (data.links && data.links['next']) {
          state.facilitiesNextPage = data.links['next']
        } else {
          state.facilitiesNextPage = null
        }
      }

      // 送信失敗件数
      state.facilities = sendFailsMerge(state.facilities, data.meta)

      // 検索件数
      state.facilitiesTotalCount = 0
      if (data.meta && data.meta['total-count']) {
        state.facilitiesTotalCount = data.meta['total-count']
      }

      // 先頭に全項目を追加
      if (params.all && params.facility_all !== null) {
        state.facilities.unshift({'id': params.facility_all['id'], 'attributes': {'facility-name': params.facility_all['name']}})
      }

      if (params.callback) {
        params.callback()
      }
    },
    [FACILITY_SEARCH_AUTOCOMPLETE_SUCCESS] (state, param) {
      console.log('FACILITY_SEARCH_AUTOCOMPLETE_SUCCESS')
      state.facilitiesAutocomplete = param.data.data
      // 先頭に全項目を追加
      var params = param.params
      if (params.all && params.facility_all !== null) {
        state.facilitiesAutocomplete.unshift({'id': params.facility_all['id'], 'attributes': {'facility-name': params.facility_all['name']}})
      }
    },
    [FACILITY_CLEAR] (state) {
      state.facilities = null
    },
    [FACILITY_AUTOCOMPLETE_CLEAR] (state) {
      state.facilitiesAutocomplete = null
    },
    [FACILITY_SELECT] (state, data) {
      console.log('FACILITY_SELECT')
      state.selectedFacilities = data.selected
      if (data.callback !== null) {
        data.callback()
      }
    },
    [FACILITY_NOTICE_GET_FAILURE] (state, data) {
      console.log('FACILITY_NOTICE_GET_FAILURE')
    },
    [FACILITY_NOTICE_GET_SUCCESS] (state, data) {
      console.log('FACILITY_NOTICE_GET_SUCCESS')
      state.facilityNotices = data.data.data
      if (data.callback !== null) {
        data.callback(data.data)
      }
    },
    [FACILITY_NOTICE_COMPLETE_FAILURE] (state, data) {
      console.log('FACILITY_NOTICE_COMPLETE_FAILURE')
      state.facilityNotify = {
        danger: true,
        message_direct: data.error
      }
      setTimeout(() => {
        state.facilityNotify = null
      }, constant.notifyShowTime.normal)
    },
    [FACILITY_NOTICE_COMPLETE_SUCCESS] (state, {data, params, callback}) {
      console.log('FACILITY_NOTICE_COMPLETE_SUCCESS')
      state.facilityNotices = state.facilityNotices.filter(function (notice) {
        if (notice.attributes['facility-notice-id'] === params.facility_notice_id) {
          notice.attributes['complete-flag'] = 1
        }
        return true
      })
      state.facilityNotify = {
        success: true,
        message_i18n: 'messages.complete'
      }
      setTimeout(() => {
        state.facilityNotify = null
      }, constant.notifyShowTime.normal)
      if (callback !== null) {
        callback(data.data)
      }
    },
    [FACILITY_NOTICE_DELETE_FAILURE] (state, data) {
      console.log('FACILITY_NOTICE_DELETE_FAILURE')
      state.facilityNotify = {
        danger: true,
        message_direct: data.error
      }
      setTimeout(() => {
        state.facilityNotify = null
      }, constant.notifyShowTime.normal)
    },
    [FACILITY_NOTICE_DELETE_SUCCESS] (state, {data, params, callback}) {
      console.log('FACILITY_NOTICE_DELETE_FAILURE')
      state.facilityNotices = state.facilityNotices.filter(function (notice) {
        return (notice.attributes['facility-notice-id'] !== params.facility_notice_id)
      })
      state.facilityNotify = {
        success: true,
        message_i18n: 'messages.delete.success'
      }
      setTimeout(() => {
        state.facilityNotify = null
      }, constant.notifyShowTime.normal)
      if (callback !== null) {
        callback(data.data)
      }
    },
    [FACILITY_SEARCH_ALL_FAILURE] (state, data) {
      console.log('FACILITY_SEARCH_ALL_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [FACILITY_SEARCH_ALL_SUCCESS] (state, {data, params}) {
      console.log('FACILITY_SEARCH_ALL_SUCCESS')
      if (params.callback) {
        params.callback(data)
      }
    },
    [FACILITY_SEARCH_BY_SHOP_FAILURE] (state, data) {
      console.log('FACILITY_SEARCH_BY_SHOP_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [FACILITY_SEARCH_BY_SHOP_SUCCESS] (state, {data, params}) {
      console.log('FACILITY_SEARCH_BY_SHOP_SUCCESS')
      if (params.callback) {
        state.searchFacilitiesByShop = data.data
        params.callback(data)
      }
    },
    [FACILITY_CHECKED] (state, data) {
      console.log('FACILITY_CHECKED')
      var id = data.facility_id
      var checked = data.checked
      if (state.facilities != null) {
        state.facilities = state.facilities.filter(function (f) {
          if (id === undefined || id === null) {
            f.checked = checked
          } else {
            if (f.id === id) {
              f.checked = checked
            }
          }
          return true
        })
      }
    },
    [FACILITY_SHOP_LIST_SAVE] (state, params) {
      console.log('FACILITY_SHOP_LIST_SAVE')
      state.shopList = params
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/facility.js